/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Führerschein)   (bipro-partner::Führerschein)
 */
export interface DrivingLicense {
  /**
   * (german: Ausstellungsdatum)
   */
  dateOfIssue?: string;
}
